<template>
  <div id="js-via-view">
    <via-chart
      v-if="assessment"
      :stats="assessment.areas"
      :reOrderable="false"
    ></via-chart>
    <v-container v-else>
      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-description">
          Character strengths are key components of who we are; we bring them
          with us in every situation of life: personal relationships, work, or
          how we spend our free time. The VIA is a great way to find out which
          Character Strengths you utilize most. The Values in Action (VIA)
          assessment categorizes all potential character values into a list of
          24 values and generates results ranked according to how an individual
          utilizes each character value.
        </span>
      </v-row>
      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-mentor-message">
          Your Mentor will work with you on when to take this assessment!
        </span>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import ViaChart from "@/components/assessments/ViaChart"

import User from "@/lib/user"
import { mapGetters } from "vuex"

export default {
  mixins: [titleMixin],
  components: { ViaChart },
  data: function() {
    return {
      title: "Character Strengths",
      userId: User.getUserId(),
      assessment: { areas: [] }
    }
  },
  created() {
    this.assessment = this.getAssessmentByType("Via")
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/assessment-text";
</style>
